var _mask, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 74,
    viewBox: "0 0 112 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_5221_1742",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56 0C44.9543 0 36 8.95431 36 20V23.9999C36 29.5228 31.5228 33.9999 26 33.9999H20C8.95431 33.9999 0 42.9542 0 53.9999C0 65.0456 8.9543 73.9999 20 73.9999H92C103.046 73.9999 112 65.0456 112 53.9999C112 42.9542 103.046 33.9999 92 33.9999H86C80.4771 33.9999 76 29.5228 76 23.9999V20C76 8.95431 67.0457 0 56 0Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 20C38 10.0589 46.0589 2 56 2V-2C43.8497 -2 34 7.84974 34 20H38ZM38 23.9999V20H34V23.9999H38ZM20 35.9999H26V31.9999H20V35.9999ZM2 53.9999C2 44.0588 10.0589 35.9999 20 35.9999V31.9999C7.84974 31.9999 -2 41.8497 -2 53.9999H2ZM20 71.9999C10.0589 71.9999 2 63.9411 2 53.9999H-2C-2 66.1502 7.84973 75.9999 20 75.9999V71.9999ZM92 71.9999H20V75.9999H92V71.9999ZM110 53.9999C110 63.9411 101.941 71.9999 92 71.9999V75.9999C104.15 75.9999 114 66.1502 114 53.9999H110ZM92 35.9999C101.941 35.9999 110 44.0588 110 53.9999H114C114 41.8497 104.15 31.9999 92 31.9999V35.9999ZM86 35.9999H92V31.9999H86V35.9999ZM74 20V23.9999H78V20H74ZM56 2C65.9411 2 74 10.0589 74 20H78C78 7.84974 68.1503 -2 56 -2V2ZM86 31.9999C81.5817 31.9999 78 28.4182 78 23.9999H74C74 30.6274 79.3726 35.9999 86 35.9999V31.9999ZM34 23.9999C34 28.4182 30.4183 31.9999 26 31.9999V35.9999C32.6274 35.9999 38 30.6274 38 23.9999H34Z",
    fill: "#F3ECDE",
    mask: "url(#path-1-inside-1_5221_1742)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnion);
export default __webpack_public_path__ + "static/media/Union.86c9ad324c7d1b401dfc834969311c92.svg";
export { ForwardRef as ReactComponent };